module.exports = __webpack_public_path__ + "static/media/空气.2f9b48ab.svg";